module.exports = __webpack_public_path__ + "static/media/9.f7bd5aa1.jpg";